"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NormalEye = void 0;
var tslib_1 = require("tslib");
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
var react_1 = tslib_1.__importStar(require("react"));
var BaseIcon_1 = tslib_1.__importDefault(require("@ad/anq-iconfont.macro/lib/components/BaseIcon"));
var NormalEye = /** @class */ (function (_super) {
    tslib_1.__extends(NormalEye, _super);
    function NormalEye() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.iconSvg = function () { return (react_1.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 1024 1024", version: "1.1", fill: "currentColor", "aria-hidden": "true", focusable: "false" },
            react_1.default.createElement("path", { d: "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3-7.7 16.2-7.7 35.2 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258s279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766z" }),
            react_1.default.createElement("path", { d: "M508 336c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176z m0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" }))); };
        return _this;
    }
    NormalEye.prototype.render = function () {
        return react_1.default.createElement(BaseIcon_1.default, tslib_1.__assign({ component: this.iconSvg }, this.props));
    };
    return NormalEye;
}(react_1.Component));
exports.NormalEye = NormalEye;
//# sourceMappingURL=NormalEye.js.map